import {Notification} from "../../utils/models/Notification";
import {Stack} from "@mui/material";
import AutoSizer from "react-virtualized-auto-sizer";
import NotificationList from "./NotificationList";

interface Props {
    notifications: Notification[];
}

interface Size {
    width: number;
    height: number;
}

export default function NotificationListAdapter({notifications}: Props) {
    // @ts-ignore
    return (
        <Stack className={"last-user-locations"} sx={{height: {md: "60vh", xs: "60vh"}}}>
            <AutoSizer>
                {({ width, height }: Size) => (
                    <NotificationList width={width} height={height} notifications={notifications}/>
                )}
            </AutoSizer>
        </Stack>
    )
}